export const convertStringToBoolean = (parameter: string,): boolean => {
  const ret = typeof parameter === 'string' && parameter.toLowerCase() === 'true';
  return ret;
};

export default convertStringToBoolean;
